import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';

import { EmiteLicenciamento } from 'pages/DetranCrv/SolicitarDocumentos/LicenciamentoVeiculo/Resultado/form';
import { Types } from './types';
import {
	licenciamentoVeiculoSuccess,
	licenciamentoVeiculoFailure,
} from './actions';

function* licenciamentoVeiculoRequest(request: {
	type: string;
	payload: EmiteLicenciamento;
}) {
	const { payload } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`servicos/${CHANNEL}/emissao/licenciamentos`,
		payload,
	);
	if (response.status === 200 || response.status === 201) {
		yield put(licenciamentoVeiculoSuccess(response));
	} else if (response.error) {
		yield put(licenciamentoVeiculoFailure(response.message));
	}
}

export default all([
	takeLatest(Types.LICENCIAMENTO_VEICULO_REQUEST, licenciamentoVeiculoRequest),
]);
